import * as React from "react"
const BoltSvg = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={ 20 }
        height={ 20 }
        fill="none"
        viewBox="0 0 30 30"
        { ...props }
    >
        <path
            fill="#FFB703"
            fillRule="evenodd"
            d="m18.697 0-3.105 12.592 7.447 1.94L11.297 30l3.105-12.58-7.441-1.951S10.875 10.313 18.697 0Z"
            clipRule="evenodd"
        />
        <path
            fill="#FED402"
            fillRule="evenodd"
            d="M6.96 15.469 18.704 0l-6.527 13.875-5.215 1.594Zm16.08-.938L11.296 30l6.527-13.875 5.215-1.594Z"
            clipRule="evenodd"
        />
        <path
            fill="#FFC803"
            fillRule="evenodd"
            d="m18.697 0-6.521 13.875 5.648 2.25 5.215-1.594-7.447-1.94L18.697 0Z"
            clipRule="evenodd"
        />
    </svg>
)
export default BoltSvg
